import React from 'react'
import styles from './CustomPhoneInput.module.scss'

const CustomPhoneInput = ({ field, form, placeholder, showError, sx, label }) => {
  return (
    <div>
      {label &&
        <div className={styles.label}>
          <label>{label}</label>
        </div>
      }
    
      <div className={`${styles.inputWrapper} ${form?.errors[`${field?.name}`] ? styles.errorBorder : ''}`}
        style={{ ...sx }}
      >
        <span className={styles.prefix}>+91</span>
        <input
          {...field}
          className={styles.customInput}
          type={'tel'}
          placeholder={placeholder ?? "XXX XXX XXXX"}
          maxLength={10}
          inputMode='numeric'
        />
      </div>
      {showError != true && form?.errors[`${field?.name}`] && <div className={styles.errorMessage}>
        {form?.errors[`${field?.name}`]}
      </div>
      }

    </div>
  )
}

export default CustomPhoneInput
